import SecondaryInspector from './SecondaryInspector';

export {
    SecondaryInspector
};
